import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import AboutAndModels from "./components/AboutAndModels";
import WhyChooseUs from "./components/WhyChooseUs";
import BrandStrip from "./components/BrandStrip";
import TestimonialsSection from "@/components/feature/TestimonialsSection";
import ContactCta from "./components/ContactCta";
import PartRequestNotice from "@/components/feature/PartRequestNotice";
import PartsWeSource from "./components/PartsWeSource";

export default function Home() {
  return (
    <div className="min-h-screen bg-white font-body">
      <Navbar />
      <main>
        <Hero />
        <AboutAndModels />
        <WhyChooseUs />
        <BrandStrip />
        <PartsWeSource />
        <TestimonialsSection
          limit={6}
          subtitle="Real reviews from mechanics, workshops and owners across Australia."
        />
        <PartRequestNotice />
        <ContactCta />
      </main>
      <Footer />
    </div>
  );
}